var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isTrivago)?_c('TrivagoConversion',{attrs:{"conversion":_vm.trivagoConversionMethod}}):_vm._e(),(_vm.isTripAdvisor && !_vm.cancellation)?_c('TripAdvisorConversion'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }